/* ========================================================
   Espace Client Sprint Transfert — SPA hash routing
   Transposé depuis /client-area-mockup/assets/app.js
   ======================================================== */
(function () {
  'use strict';

  var ROUTES = {
    '#/dashboard':   'dashboard',
    '#/commandes':   'commandes',
    '#/fichiers':    'fichiers',
    '#/corrections': 'corrections',
    '#/reorder':     'reorder',
    '#/factures':    'factures',
    '#/fidelite':    'fidelite',
    '#/profil':      'profil',
    '#/ressources':  'ressources',
    '#/support':     'support'
  };
  var DEFAULT_ROUTE = '#/dashboard';

  function fmtEUR(n) {
    if (typeof n !== 'number' || isNaN(n)) return '0,00 €';
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  var JWT_KEY = 'ca_jwt_v1';
  var JWT_EXP_KEY = 'ca_jwt_exp_v1';

  function getMeta(name) {
    var m = document.querySelector('meta[name="' + name + '"]');
    return m ? m.getAttribute('content') : '';
  }

  function apiBase() {
    var b = getMeta('client-api-base') || 'https://printflow.pro';
    return b.charAt(b.length - 1) === '/' ? b.slice(0, -1) : b;
  }

  function getStoredJwt() {
    var exp = parseInt(localStorage.getItem(JWT_EXP_KEY) || '0', 10);
    if (!exp || exp <= Date.now()) return '';
    return localStorage.getItem(JWT_KEY) || '';
  }
  function storeJwt(t, e) {
    localStorage.setItem(JWT_KEY, t);
    localStorage.setItem(JWT_EXP_KEY, String(e || Date.now() + 55 * 60 * 1000));
  }
  function exchangeJwt() {
    var cid = getMeta('client-shopify-customer-id');
    var em  = getMeta('client-shopify-customer-email');
    var sh  = getMeta('client-shopify-shop');
    if (!cid) return Promise.resolve('');
    return fetch(apiBase() + '/api/client/auth', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shopifyCustomerId: cid, shopifyCustomerEmail: em, shopifyShop: sh })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.token) { storeJwt(d.token, d.expiresAt ? new Date(d.expiresAt).getTime() : null); return d.token; }
        return '';
      }).catch(function () { return ''; });
  }
  function ensureToken() {
    var t = getStoredJwt();
    return t ? Promise.resolve(t) : exchangeJwt();
  }

  function apiFetch(path, opts, _retried) {
    opts = opts || {};
    return ensureToken().then(function (token) {
      var headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
      if (token) headers['Authorization'] = 'Bearer ' + token;
      var url = (path.indexOf('http') === 0) ? path : (apiBase() + path);
      return fetch(url, Object.assign({}, opts, { headers: headers })).then(function (r) {
        if (r.status === 401 && !_retried) {
          // Token invalide (secret changé, expiré, etc.) : on nettoie et on re-tente une fois
          localStorage.removeItem(JWT_KEY);
          localStorage.removeItem(JWT_EXP_KEY);
          return apiFetch(path, opts, true);
        }
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    });
  }

  /* ─────── Refresh dashboard data ─────── */
  function refreshDashboard() {
    apiFetch('/api/client/dashboard').then(function (d) {
      var amt = document.querySelector('[data-credit-amount]');
      var cur = document.querySelector('[data-credit-currency]');
      if (amt && typeof d.credits === 'number') {
        amt.textContent = d.credits.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      if (cur) cur.textContent = d.creditsCurrency === 'EUR' ? '€' : (d.creditsCurrency || '€');
    }).catch(function (e) { console.warn('[client-area] dashboard fetch failed:', e); });
  }

  /* ─────── Header offset (intégration header Shopify) ─────── */
  function measureHeaderOffset() {
    if (!document.querySelector('.client-area')) return;
    var sels = [
      'header[role="banner"]', '.header-wrapper', '.section-header',
      'header.header', '[id^="shopify-section"] header',
      'shopify-section.header-section', '.section--header'
    ];
    var header = null;
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) { header = el; break; }
    }
    if (!header) {
      var s = document.querySelector('body > shopify-section, body > .shopify-section');
      if (s) header = s;
    }
    if (!header) { document.documentElement.style.setProperty('--ca-header-offset', '0px'); return; }
    var rect = header.getBoundingClientRect();
    var st = getComputedStyle(header);
    var sticky = st.position === 'sticky' || st.position === 'fixed';
    if (!sticky) {
      var p = header.parentElement;
      while (p && p !== document.body) {
        var ps = getComputedStyle(p);
        if (ps.position === 'sticky' || ps.position === 'fixed') { sticky = true; break; }
        p = p.parentElement;
      }
    }
    document.documentElement.style.setProperty('--ca-header-offset', (sticky ? rect.height : 0) + 'px');
  }

  /* ─────── Routing ─────── */
  function activateSection(route) {
    var slug = ROUTES[route] || ROUTES[DEFAULT_ROUTE];
    document.querySelectorAll('.client-area .ca-section').forEach(function (el) {
      el.classList.toggle('active', el.getAttribute('data-section') === slug);
    });
    document.querySelectorAll('.client-area .nav a[data-route]').forEach(function (a) {
      a.classList.toggle('active', a.getAttribute('data-route') === route);
    });
    document.title = (a11yLabel(slug) || 'Espace client') + ' · Sprint Transfert';
    // scroll up
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function a11yLabel(slug) {
    var map = {
      dashboard: 'Tableau de bord',
      commandes: 'Mes commandes',
      fichiers: 'Bibliothèque',
      corrections: 'Corrections',
      reorder: 'Commander à nouveau',
      factures: 'Factures',
      fidelite: 'Fidélité',
      profil: 'Profil & marque',
      ressources: 'Ressources',
      support: 'Support'
    };
    return map[slug];
  }

  function currentRoute() {
    return ROUTES[window.location.hash] ? window.location.hash : DEFAULT_ROUTE;
  }

  function handleRouting() {
    activateSection(currentRoute());
  }

  /* ─────── Filtres (commandes) ─────── */
  function wireFilterGroups() {
    document.querySelectorAll('.client-area .filter-group').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn || !group.contains(btn)) return;
        group.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var filter = btn.getAttribute('data-filter');
        if (filter) applyOrdersFilter(filter);
      });
    });
  }

  function applyOrdersFilter(filter) {
    var rows = document.querySelectorAll('.client-area [data-orders-body] tr[data-status]');
    rows.forEach(function (tr) {
      var s = tr.getAttribute('data-status');
      tr.style.display = (filter === 'all' || s === filter) ? '' : 'none';
    });
  }

  /* ─────── FAQ accordéon ─────── */
  function wireFaq() {
    document.querySelectorAll('.client-area .faq-item').forEach(function (item) {
      item.addEventListener('click', function () { item.classList.toggle('open'); });
    });
  }

  /* ─────── Détail commande (toggle liste / détail) ─────── */
  var _filesFetchedFor = {};
  function showOrderDetail(orderId) {
    var list = document.querySelector('[data-orders-list]');
    var details = document.querySelectorAll('[data-order-detail]');
    if (list) list.hidden = true;
    details.forEach(function (d) {
      d.hidden = d.getAttribute('data-order-detail') !== String(orderId);
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Fetch les fichiers clients via backend (Liquid ne les expose pas)
    if (!_filesFetchedFor[orderId]) {
      _filesFetchedFor[orderId] = true;
      fetchOrderFiles(orderId);
    }
  }

  function fetchOrderFiles(orderId) {
    apiFetch('/api/client/orders/' + encodeURIComponent(orderId)).then(function (res) {
      var order = res && res.order;
      if (!order || !order.files) return;
      // Grouper les fichiers par line item — pour l'instant on les injecte tous
      // en haut de la première ligne (simpliste mais effectif).
      var detail = document.querySelector('[data-order-detail="' + orderId + '"]');
      if (!detail) return;
      var lines = detail.querySelectorAll('.order-line-item');
      if (lines.length === 0) return;
      var firstLine = lines[0];
      injectFiles(firstLine, order.files);
    }).catch(function (e) {
      console.warn('[client-area] fetch order files failed:', e);
    });
  }

  function injectFiles(lineItem, files) {
    var imgExts = ['png','jpg','jpeg','gif','webp','svg'];
    var primary = files[0];
    if (!primary || !primary.url) return;
    var extMatch = primary.url.split('?')[0].split('.').pop().toLowerCase();
    var isImage = imgExts.indexOf(extMatch) !== -1;

    // Remplacer le thumb
    var thumb = lineItem.querySelector('.order-line-thumb');
    if (thumb) {
      if (isImage) {
        thumb.classList.add('order-line-thumb-large');
        thumb.innerHTML = '<a href="' + primary.url + '" target="_blank" rel="noopener" title="Ouvrir en grand"><img src="' + primary.url + '" alt="Visuel client" loading="lazy"></a>';
      } else {
        thumb.innerHTML = '<a href="' + primary.url + '" target="_blank" rel="noopener" class="order-line-thumb-file" title="Télécharger"><span style="font-size:11px;font-weight:700;color:var(--ca-primary)">.' + extMatch.toUpperCase() + '</span></a>';
      }
    }
    // Ajouter liste fichiers dans .order-line-info
    var info = lineItem.querySelector('.order-line-info');
    if (info) {
      var existing = info.querySelector('.order-line-files');
      if (existing) existing.remove();
      var list = document.createElement('div');
      list.className = 'order-line-files';
      list.innerHTML = files.map(function (f) {
        var fname = (f.url || '').split('/').pop().split('?')[0];
        var fext = fname.split('.').pop().toLowerCase();
        return '<a href="' + f.url + '" target="_blank" rel="noopener" class="order-line-file">📎 ' + (f.name || fname).substring(0, 40) + ' <span style="color:var(--ca-text-muted);font-weight:500">(.' + fext + ')</span></a>';
      }).join('');
      info.appendChild(list);
    }
  }
  function hideOrderDetail() {
    var list = document.querySelector('[data-orders-list]');
    var details = document.querySelectorAll('[data-order-detail]');
    if (list) list.hidden = false;
    details.forEach(function (d) { d.hidden = true; });
  }
  function wireOrderDetail() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-order-detail-open]');
      if (openBtn) {
        e.preventDefault();
        showOrderDetail(openBtn.getAttribute('data-order-detail-open'));
        return;
      }
      var closeBtn = e.target.closest('[data-order-detail-close]');
      if (closeBtn) {
        e.preventDefault();
        hideOrderDetail();
      }
    });
  }

  /* ─────── Données custom (backend) ─────── */
  // Le backend n'est pas encore branché: on utilise des données de démo
  // côté client. Quand l'API sera prête, remplacer par apiFetch('/api/client/files')
  var DEMO_FILES = [
    { id: 1,  name: 'logo_boutique_v3',     ext: 'png', version: 3, size: '2.8 Mo',  dims: '3508×2480', dpi: 300, lastUsed: '17 avr 2026', expiresAt: '17 oct 2026', daysLeft: 182, orders: 4, format: 'A3' },
    { id: 2,  name: 'campagne_ete_final',   ext: 'pdf', version: 1, size: '8.1 Mo',  dims: '2480×3508', dpi: 300, lastUsed: '15 avr 2026', expiresAt: '15 oct 2026', daysLeft: 180, orders: 1, format: 'A4' },
    { id: 3,  name: 'sticker_rond_logo',    ext: 'ai',  version: 2, size: '5.4 Mo',  dims: '1181×1181', dpi: 300, lastUsed: '13 avr 2026', expiresAt: '13 oct 2026', daysLeft: 178, orders: 2, format: '10×10' },
    { id: 4,  name: 'packaging_noel',       ext: 'png', version: 1, size: '12.3 Mo', dims: '4961×7016', dpi: 300, lastUsed: '10 avr 2026', expiresAt: '10 oct 2026', daysLeft: 175, orders: 1, format: 'A2' },
    { id: 5,  name: 'collec_capsule',       ext: 'pdf', version: 2, size: '6.2 Mo',  dims: '2480×3508', dpi: 300, lastUsed: '04 avr 2026', expiresAt: '04 oct 2026', daysLeft: 169, orders: 1, format: 'A4' },
    { id: 6,  name: 'logo_simple_monochrome', ext: 'png', version: 1, size: '1.1 Mo',  dims: '1500×1500', dpi: 300, lastUsed: '28 mar 2026', expiresAt: '28 sep 2026', daysLeft: 163, orders: 3, format: 'A5' },
    { id: 7,  name: 'affiche_event_mars',   ext: 'pdf', version: 1, size: '14.2 Mo', dims: '4961×7016', dpi: 300, lastUsed: '22 mar 2026', expiresAt: '22 sep 2026', daysLeft: 157, orders: 1, format: 'A2' },
    { id: 8,  name: 'pictos_collection',    ext: 'ai',  version: 4, size: '3.9 Mo',  dims: '2000×2000', dpi: 300, lastUsed: '18 mar 2026', expiresAt: '18 sep 2026', daysLeft: 153, orders: 5, format: 'A4' },
    { id: 9,  name: 'signature_manuscrite', ext: 'png', version: 1, size: '0.4 Mo',  dims: '800×400',   dpi: 300, lastUsed: '25 oct 2025', expiresAt: '25 avr 2026', daysLeft: 7,   orders: 7, format: 'A6' },
    { id: 10, name: 'pattern_geometrique',  ext: 'pdf', version: 2, size: '9.8 Mo',  dims: '3508×4961', dpi: 300, lastUsed: '20 nov 2025', expiresAt: '20 mai 2026', daysLeft: 33,  orders: 2, format: 'A3' }
  ];

  function retentionBadge(daysLeft, expiresAt) {
    if (daysLeft <= 14) return '<div class="retention-badge retention-danger">⚠ Expire dans ' + daysLeft + ' j</div>';
    if (daysLeft <= 45) return '<div class="retention-badge retention-warning">⏳ Expire dans ' + daysLeft + ' j</div>';
    return '<div class="retention-badge retention-ok">Conservé jusqu\'au ' + expiresAt + '</div>';
  }

  function renderFiles() {
    var grid = document.querySelector('[data-files-grid]');
    if (!grid) return;
    grid.innerHTML = DEMO_FILES.map(function (f) {
      return '<div class="file-card' + (f.daysLeft <= 14 ? ' file-card-urgent' : '') + '">' +
        '<div class="file-preview">' +
          '<span class="fmt-tag">' + f.format + '</span>' +
          (f.version > 1 ? '<span class="version">v' + f.version + '</span>' : '') +
          '<span>.' + f.ext.toUpperCase() + '</span>' +
        '</div>' +
        '<div class="file-meta">' +
          '<div class="file-name">' + f.name + '.' + f.ext + '</div>' +
          '<div class="file-sub">' + f.dims + ' · ' + f.dpi + ' DPI · ' + f.size + '</div>' +
          '<div class="file-sub" style="margin-top:3px">Commandé ' + f.orders + '× · dernière fois le ' + f.lastUsed + '</div>' +
          retentionBadge(f.daysLeft, f.expiresAt) +
        '</div>' +
        '<div class="file-actions">' +
          '<button class="btn btn-sm" title="Aperçu">👁</button>' +
          '<button class="btn btn-sm" title="Télécharger">⬇</button>' +
          '<button class="btn btn-sm btn-primary" style="flex:1">Recommander</button>' +
        '</div>' +
      '</div>';
    }).join('');

    var count = document.querySelector('[data-file-count]');
    var size = document.querySelector('[data-file-size]');
    if (count) count.textContent = DEMO_FILES.length;
    if (size) {
      var total = DEMO_FILES.reduce(function (s, f) { return s + parseFloat(f.size); }, 0);
      size.textContent = total.toFixed(1) + ' Mo';
    }
  }

  function renderReorder() {
    var grid = document.querySelector('[data-reorder-grid]');
    if (!grid) return;
    var sorted = DEMO_FILES.slice().sort(function (a, b) { return b.orders - a.orders; }).slice(0, 6);
    grid.innerHTML = sorted.map(function (f) {
      return '<div class="reorder-tile">' +
        '<div class="reorder-count">Commandé ' + f.orders + '× · format ' + f.format + '</div>' +
        '<div class="reorder-name">' + f.name + '.' + f.ext + '</div>' +
        '<div class="file-sub">' + f.dims + ' · ' + f.dpi + ' DPI</div>' +
        '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:auto;padding-top:10px;border-top:1px dashed var(--ca-border)">' +
          '<div>' +
            '<div style="font-size:11px;color:var(--ca-text-tertiary);text-transform:uppercase;letter-spacing:0.08em;font-weight:600">Dès</div>' +
            '<div class="reorder-price">1,40 € / planche</div>' +
          '</div>' +
          '<button class="btn btn-primary">↻ Recommander</button>' +
        '</div>' +
      '</div>';
    }).join('');

    // Dashboard mini-reorder (top 4)
    var mini = document.querySelector('[data-reorder-mini]');
    if (mini) {
      mini.innerHTML = sorted.slice(0, 4).map(function (f) {
        return '<div class="reorder-tile">' +
          '<div class="reorder-count">Commandé ' + f.orders + '× · format ' + f.format + '</div>' +
          '<div class="reorder-name">' + f.name + '.' + f.ext + '</div>' +
          '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:auto;padding-top:8px">' +
            '<span class="reorder-price">Dès 1,40 €/pl.</span>' +
            '<button class="btn btn-sm btn-primary">Recommander</button>' +
          '</div>' +
        '</div>';
      }).join('');
    }
  }

  /* ─────── Upload (drag & drop visuel) ─────── */
  function wireUpload() {
    document.querySelectorAll('.client-area .upload').forEach(function (zone) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        zone.addEventListener(evt, function (e) { e.preventDefault(); zone.classList.add('drag'); });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        zone.addEventListener(evt, function (e) { e.preventDefault(); zone.classList.remove('drag'); });
      });
    });
  }

  /* ─────── Init ─────── */
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.client-area')) return;
    measureHeaderOffset();
    window.addEventListener('resize', measureHeaderOffset);
    window.addEventListener('scroll', measureHeaderOffset, { passive: true });
    handleRouting();
    window.addEventListener('hashchange', handleRouting);

    wireFilterGroups();
    wireFaq();
    wireUpload();
    wireOrderDetail();
    renderFiles();
    renderReorder();

    // Charge données dynamiques (crédits magasin, loyalty)
    refreshDashboard();
  });

  // Expose pour debug
  window.ClientArea = {
    fmtEUR: fmtEUR,
    apiFetch: apiFetch,
    refreshFiles: renderFiles
  };
})();
